module.exports = __webpack_public_path__ + "static/portfolio-512-bb98d7af9df93e281bd82a29244fab70.png";